(() => {
  const CARD_PRICE_NOTE = 'U.S. pricing only';
  const MENA_COUNTRY_CODES = new Set(['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'OM', 'QA', 'SA', 'TN', 'YE']);
  const COUNTRY_NAMES = {
    AE: 'United Arab Emirates',
    BH: 'Bahrain',
    DZ: 'Algeria',
    EG: 'Egypt',
    IQ: 'Iraq',
    JO: 'Jordan',
    KW: 'Kuwait',
    LB: 'Lebanon',
    LY: 'Libya',
    MA: 'Morocco',
    OM: 'Oman',
    QA: 'Qatar',
    SA: 'Saudi Arabia',
    TN: 'Tunisia',
    US: 'United States',
    YE: 'Yemen',
  };
  const ROUTING_KEY = 'accushoot:mena-country-routing:v1';
  const TIMEZONE_COUNTRY_MAP = {
    'Asia/Riyadh': 'SA',
    'Asia/Dubai': 'AE',
  };
  const FALLBACK_COUNTRY_MAP = {
    AE: 'SA',
  };

  function getTimeZone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      return '';
    }
  }

  function getAvailableCountries() {
    return new Set(
      Array.from(document.querySelectorAll('localization-form a[data-value]'))
        .map((item) => item.dataset.value)
        .filter(Boolean)
    );
  }

  function getLocalizationForm() {
    const countryInput = document.querySelector('localization-form input[name="country_code"]');
    return countryInput ? countryInput.form : null;
  }

  function isMenaCountry() {
    const country =
      (window.Shopify && window.Shopify.country) ||
      document.querySelector('localization-form input[name="country_code"]')?.value ||
      '';
    return MENA_COUNTRY_CODES.has(country);
  }

  function setReturnPath(form) {
    const returnInput = form.querySelector('input[name="return_to"]');
    if (!returnInput) return;

    const returnUrl = new URL(window.location.href);
    returnUrl.searchParams.delete('country');
    returnInput.value = `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`;
  }

  function hasRoutingAttempt() {
    try {
      return window.sessionStorage.getItem(ROUTING_KEY);
    } catch (error) {
      return false;
    }
  }

  function rememberRoutingAttempt(currentCountry, targetCountry) {
    try {
      window.sessionStorage.setItem(ROUTING_KEY, `${currentCountry || ''}->${targetCountry}`);
    } catch (error) {
      // A failed storage write should not block the native Shopify localization form.
    }
  }

  function routeMenaVisitor() {
    if (hasRoutingAttempt()) return;

    const targetFromTimeZone = TIMEZONE_COUNTRY_MAP[getTimeZone()];
    if (!targetFromTimeZone) return;

    const currentCountry = window.Shopify && window.Shopify.country;
    if (currentCountry === targetFromTimeZone) return;

    const availableCountries = getAvailableCountries();
    let targetCountry = targetFromTimeZone;

    if (!availableCountries.has(targetCountry)) {
      targetCountry = FALLBACK_COUNTRY_MAP[targetCountry];
    }

    if (!targetCountry || targetCountry === currentCountry || !availableCountries.has(targetCountry)) return;

    const form = getLocalizationForm();
    const countryInput = form && form.querySelector('input[name="country_code"]');
    if (!form || !countryInput) return;

    rememberRoutingAttempt(currentCountry, targetCountry);
    countryInput.value = targetCountry;
    setReturnPath(form);
    form.submit();
  }

  function getCheckmarkSvg() {
    return '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9"><path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/></svg>';
  }

  function buildCountryItem(countryCode, currentCountryCode) {
    const countryName = COUNTRY_NAMES[countryCode] || countryCode;
    const isCurrent = countryCode === currentCountryCode;
    const item = document.createElement('li');
    item.className = 'disclosure__item';
    item.tabIndex = -1;
    item.innerHTML = `
      <a class="link link--text disclosure__link caption-large focus-inset" href="#"${isCurrent ? ' aria-current="true"' : ''} data-value="${countryCode}" id="${countryName}">
        <span class="${isCurrent ? '' : 'visibility-hidden'}">${getCheckmarkSvg()}</span>
        <span class="country">${countryName}</span>
      </a>
    `;
    return item;
  }

  function bindCountryLink(localizationForm, link) {
    if (link.dataset.accushootFlatCountryBound) return;
    link.dataset.accushootFlatCountryBound = 'true';
    link.addEventListener('click', (event) => {
      const countryInput = localizationForm.querySelector('input[name="country_code"]');
      const form = countryInput && countryInput.form;
      if (!countryInput || !form) return;

      event.preventDefault();
      countryInput.value = link.dataset.value;
      setReturnPath(form);
      form.submit();
    });
  }

  function normalizeCountrySelectors() {
    document.querySelectorAll('localization-form').forEach((localizationForm) => {
      const countryInput = localizationForm.querySelector('input[name="country_code"]');
      const currentCountryCode = countryInput && countryInput.value;
      const countriesList = localizationForm.querySelector('.countries');

      localizationForm.querySelectorAll('.localization-form__currency').forEach((currency) => currency.remove());
      localizationForm.querySelectorAll('.popular-countries,.country-selector__group').forEach((group) => group.remove());

      if (countriesList) {
        const oldMenaOption = countriesList.querySelector('.country-selector__mena-option');
        if (oldMenaOption) {
          const markerCodes = Array.from(oldMenaOption.querySelectorAll('[data-mena-country-code]'))
            .map((marker) => marker.dataset.menaCountryCode)
            .filter((countryCode) => MENA_COUNTRY_CODES.has(countryCode));
          const fallbackCode = oldMenaOption.querySelector('a[data-value]')?.dataset.value;
          const countryCodes = markerCodes.length ? markerCodes : [fallbackCode].filter(Boolean);
          const countryItems = countryCodes.map((countryCode) => buildCountryItem(countryCode, currentCountryCode));

          oldMenaOption.replaceWith(...countryItems);
          countryItems.forEach((item) => {
            const link = item.querySelector('a[data-value]');
            if (link) bindCountryLink(localizationForm, link);
          });
        }
      }

      localizationForm.querySelectorAll('a[data-value]').forEach((link) => {
        const countryName = link.querySelector('.country')?.textContent.trim() || COUNTRY_NAMES[link.dataset.value] || link.dataset.value;
        link.id = countryName;
        bindCountryLink(localizationForm, link);
      });

      const activeLink =
        localizationForm.querySelector(`a[data-value="${currentCountryCode}"]`) ||
        localizationForm.querySelector('a[aria-current="true"]');
      const buttonLabel = localizationForm.querySelector('.localization-form__select > span');
      const activeCountryName =
        activeLink?.querySelector('.country')?.textContent.trim() ||
        COUNTRY_NAMES[currentCountryCode] ||
        buttonLabel?.textContent.replace(/\|.*/, '').trim();

      if (buttonLabel && activeCountryName) {
        buttonLabel.textContent = activeCountryName;
      }
    });
  }

  function ensureCountrySelectorFlatStyle() {
    if (document.getElementById('AccuShootFlatCountrySelectorStyle')) return;

    const style = document.createElement('style');
    style.id = 'AccuShootFlatCountrySelectorStyle';
    style.textContent =
      '.header-localization .disclosure__list-wrapper.country-selector{background:#111!important;border-color:rgba(255,255,255,.18)!important;color:#fff!important;}' +
      '.header-localization .country-filter{background:#111!important;}' +
      '.header-localization .disclosure__link{color:rgba(255,255,255,.86)!important;}' +
      '.header-localization .disclosure__link:hover,.header-localization .disclosure__link:focus-visible,.header-localization .disclosure__link[aria-current="true"]{background:rgba(255,255,255,.08)!important;color:#fff!important;}' +
      '.header-localization .country-selector__close-button.link{color:#fff!important;}';
    document.head.appendChild(style);
  }

  function ensureCollectionNoteStyle() {
    if (document.getElementById('AccuShootCollectionPriceNoteStyle')) return;

    const style = document.createElement('style');
    style.id = 'AccuShootCollectionPriceNoteStyle';
    style.textContent =
      '.card-price-region-note{margin:.25rem 0 0!important;color:rgba(var(--color-foreground),.7);line-height:1.3;max-width:18rem!important;}';
    document.head.appendChild(style);
  }

  function ensureInternationalNoteLayoutStyle() {
    if (document.getElementById('AccuShootInternationalNoteLayoutStyle')) return;

    const style = document.createElement('style');
    style.id = 'AccuShootInternationalNoteLayoutStyle';
    style.textContent = '.collection-international-pricing-note{display:none!important;}';
    document.head.appendChild(style);
  }

  function ensureMenaNoPriceStyle() {
    if (document.getElementById('AccuShootMenaNoPriceStyle')) return;

    const style = document.createElement('style');
    style.id = 'AccuShootMenaNoPriceStyle';
    style.textContent =
      'body.accushoot-mena-no-prices .price,' +
      'body.accushoot-mena-no-prices .price-region-note,' +
      'body.accushoot-mena-no-prices .card-price-region-note,' +
      'body.accushoot-mena-no-prices .product__tax,' +
      'body.accushoot-mena-no-prices .volume-pricing-note,' +
      'body.accushoot-mena-no-prices .card__information-volume-pricing-note,' +
      'body.accushoot-mena-no-prices price-per-item,' +
      'body.accushoot-mena-no-prices volume-pricing,' +
      'body.accushoot-mena-no-prices .cart-item__price-wrapper,' +
      'body.accushoot-mena-no-prices .totals__total-value,' +
      'body.accushoot-mena-no-prices .cart-pricing-disclaimer,' +
      'body.accushoot-mena-no-prices .cart-notification__pricing-disclaimer,' +
      'body.accushoot-mena-no-prices .cart__dynamic-checkout-buttons,' +
      'body.accushoot-mena-no-prices #cart-notification-form,' +
      'body.accushoot-mena-no-prices .cart__checkout-button,' +
      'body.accushoot-mena-no-prices product-form,' +
      'body.accushoot-mena-no-prices .quick-add,' +
      'body.accushoot-mena-no-prices quick-add-bulk,' +
      'body.accushoot-mena-no-prices .product-form__quantity,' +
      'body.accushoot-mena-no-prices .shopify-payment-button{display:none!important;}';
    document.head.appendChild(style);
  }

  function ensureMenaProductContactButton() {
    const productInfo = document.querySelector('.product__info-container');
    if (!productInfo || productInfo.querySelector('a[href^="mailto:shopmena@accushoot.com"]')) return;

    const title =
      productInfo.querySelector('.product__title h1')?.textContent.trim() ||
      document.querySelector('h1')?.textContent.trim() ||
      document.title.replace(/\s*[|-].*$/, '').trim();
    const wrapper = document.createElement('div');
    wrapper.className = 'product-form__buttons accushoot-mena-contact-fallback';
    wrapper.style.marginTop = '2.5rem';
    wrapper.style.marginBottom = '2.5rem';
    wrapper.innerHTML = `<a href="mailto:shopmena@accushoot.com?subject=Inquiry:%20${encodeURIComponent(
      title
    )}" class="button button--primary button--full-width">AccuShoot Email</a>`;

    const titleBlock = productInfo.querySelector('.product__title');
    if (titleBlock) {
      titleBlock.insertAdjacentElement('afterend', wrapper);
    } else {
      productInfo.prepend(wrapper);
    }
  }

  function applyMenaNoPriceFallback() {
    if (!isMenaCountry()) return;

    ensureMenaNoPriceStyle();
    document.body.classList.add('accushoot-mena-no-prices');
    document.querySelectorAll('.price-region-note,.card-price-region-note,.cart-pricing-disclaimer,.cart-notification__pricing-disclaimer').forEach((note) => note.remove());
    ensureMenaProductContactButton();
  }

  function removeCollectionInternationalNotes() {
    document.querySelectorAll('.collection-international-pricing-note').forEach((note) => note.remove());
  }

  function normalizeCollectionPricingNotes() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    ensureCollectionNoteStyle();
    grid.querySelectorAll('.card-price-region-note').forEach((note) => {
      if (note.textContent.trim() !== CARD_PRICE_NOTE) {
        note.textContent = CARD_PRICE_NOTE;
      }
    });
    removeCollectionInternationalNotes();
  }

  function applyCollectionPriceNotesFallback() {
    const grid = document.getElementById('product-grid');
    const staleNote = document.querySelector('.product-grid-container .price-region-note');
    if (!grid || !staleNote || grid.querySelector('.card-price-region-note')) return;

    ensureCollectionNoteStyle();
    grid.querySelectorAll('.card-information .price').forEach((price) => {
      const cardInfo = price.closest('.card-information');
      if (!cardInfo || cardInfo.querySelector('.card-price-region-note')) return;

      const note = document.createElement('p');
      note.className = 'card-price-region-note caption';
      note.textContent = CARD_PRICE_NOTE;
      price.insertAdjacentElement('afterend', note);
    });

    staleNote.remove();
  }

  async function refreshStaleCollectionGrid() {
    const grid = document.getElementById('product-grid');
    const staleNote = document.querySelector('.product-grid-container .price-region-note');
    if (!grid || !staleNote || grid.querySelector('.card-price-region-note')) return;

    const sectionId = grid.dataset.id;
    const sectionElement = sectionId && document.getElementById(`shopify-section-${sectionId}`);
    if (!sectionId || !sectionElement || !window.fetch || !window.DOMParser) {
      applyCollectionPriceNotesFallback();
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Collection section refresh failed');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshSection = doc.getElementById(sectionElement.id);
      if (!freshSection || !freshSection.querySelector('.card-price-region-note')) {
        applyCollectionPriceNotesFallback();
        return;
      }

      sectionElement.replaceWith(freshSection);
    } catch (error) {
      applyCollectionPriceNotesFallback();
    }
  }

  function onReady() {
    ensureCountrySelectorFlatStyle();
    normalizeCountrySelectors();
    ensureInternationalNoteLayoutStyle();
    applyMenaNoPriceFallback();
    refreshStaleCollectionGrid();
    normalizeCollectionPricingNotes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
